import React from "react";
import Pizzagif from "../../assets/components-icons/pizza-loading.gif";

const PizzaLoading = () => {
  return (
    <>
      <div className="loading-gif">
        <img src={Pizzagif} alt="gif" />
      </div>
    </>
  );
};

export { PizzaLoading as default };
